module.exports = __webpack_public_path__ + "static/media/Shrek.31b47cbd.jpg";